import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

const COLORS = {
  portfolio_return: "#1748C4",   // institutional blue (portfolio)
  nifty50_return: "#0E1B33",     // deep navy
  sensex_return: "#248750",      // institutional green
  nifty500_return: "#DB891C",    // amber
};

const LABELS = {
  portfolio_return: "Portfolio",
  nifty50_return: "NIFTY 50",
  sensex_return: "SENSEX",
  nifty500_return: "NIFTY 500",
};

export default function PerformanceChart({ series }) {
  if (!series || series.length === 0) {
    return (
      <div className="card-noir p-12 text-center text-sm text-muted-foreground rounded-lg">
        Not enough data to plot performance yet.
      </div>
    );
  }
  return (
    <div className="card-noir p-4 rounded-lg" data-testid="performance-chart">
      <ResponsiveContainer width="100%" height={340}>
        <LineChart data={series} margin={{ top: 16, right: 16, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#DDD2BA" strokeDasharray="0" vertical={false} />
          <XAxis
            dataKey="date"
            stroke="#565E6F"
            fontSize={11}
            tick={{ fontFamily: "JetBrains Mono" }}
            tickFormatter={(d) => d.slice(2, 7)}
          />
          <YAxis
            stroke="#565E6F"
            fontSize={11}
            tick={{ fontFamily: "JetBrains Mono" }}
            tickFormatter={(v) => `${v}%`}
            width={50}
          />
          <Tooltip
            contentStyle={{
              background: "#FFFFFF",
              border: "1px solid #DDD2BA",
              borderRadius: 8,
              fontFamily: "JetBrains Mono",
              fontSize: 12,
              color: "#0E1A2E",
              padding: "8px 12px",
              boxShadow: "0 6px 24px rgba(14,26,46,0.08)",
            }}
            cursor={{ stroke: "#1748C4", strokeOpacity: 0.4, strokeDasharray: "2 4" }}
            formatter={(v, n) => [`${Number(v).toFixed(2)}%`, LABELS[n] || n]}
          />
          <Legend
            verticalAlign="top"
            height={32}
            iconType="line"
            wrapperStyle={{ fontFamily: "JetBrains Mono", fontSize: 11, color: "#565E6F" }}
            formatter={(v) => LABELS[v] || v}
          />
          <Line type="monotone" dataKey="portfolio_return" stroke={COLORS.portfolio_return} strokeWidth={2.5} dot={false} />
          <Line type="monotone" dataKey="nifty50_return" stroke={COLORS.nifty50_return} strokeWidth={1.5} dot={false} />
          <Line type="monotone" dataKey="sensex_return" stroke={COLORS.sensex_return} strokeWidth={1.5} strokeDasharray="5 3" dot={false} />
          <Line type="monotone" dataKey="nifty500_return" stroke={COLORS.nifty500_return} strokeWidth={1.5} strokeDasharray="2 3" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
